import { render, staticRenderFns } from "./RadioButton.html?vue&type=template&id=845a4524&scoped=true&"
import script from "./RadioButton.ts?vue&type=script&lang=ts&"
export * from "./RadioButton.ts?vue&type=script&lang=ts&"
import style0 from "./RadioButton.scss?vue&type=style&index=0&id=845a4524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845a4524",
  null
  
)

export default component.exports